// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"37":"de55bd36ea12240d7be4","76":"0122a4eba627df8578d7"}[chunkId] + ".chunk.js";
};